import Card from 'components/Card'
import { dateFormat } from 'utils'
import { add, sub } from 'date-fns'
import * as locales from 'react-date-range/dist/locale'
import './styles.scss'
import { DateRange } from 'react-date-range'
import CustomListbox from 'components/listbox'

export const listboxOptions = [
  {
    key: 'oneWeek',
    id: 'oneWeek',
    name: 'Última semana'
  },
  {
    key: 'oneMonth',
    id: 'oneMonth',
    name: 'Último mes'
  },
  {
    key: 'threeMonths',
    id: 'threeMonths',
    name: 'Últimos tres meses'
  },
  {
    key: 'other',
    id: 'other',
    name: 'Otro intervalo'
  }
]

export function FilterInputs({
  customPeriod,
  setDateRange,
  setCalendarVisible,
  selectedPeriod,
  setSelectedPeriod,
  isCalendarVisible,
  setCustomPeriod
}) {
  const handlePeriodSelection = (e) => {
    setSelectedPeriod(e)
    setCalendarVisible(e.id === 'other')

    const created_until = null
    let created_from
    switch (e.id) {
      case 'oneWeek':
        created_from = add(new Date(), { weeks: -1 })
        break
      case 'oneMonth':
        created_from = add(new Date(), { months: -1 })
        break
      case 'threeMonths':
        created_from = add(new Date(), { days: -89 })
        break
      default:
        break
    }

    setDateRange({ created_from, created_until })
  }

  return (
    <>
      <div className='flex flex-col'>
        <p className='font-medium text-xs text-gray-900 my-6 mx-2 md:mx-0'>
          Seleccioná el intervalo de fechas que deseas consultar.
        </p>
        <CustomListbox
          selectedValue={selectedPeriod}
          setSelectedValue={(e) => handlePeriodSelection(e)}
          list={listboxOptions}
        />
        {selectedPeriod.id === 'other' && (
          <div className='flex justify-between gap-5 my-4'>
            <Card className='w-full bg-white px-3 !py-2 rounded-md h-fit'>
              <p className='text-gray-900 text-2xs'>Desde</p>
              <p>{dateFormat(customPeriod?.startDate, 'dd-MM-yyyy')}</p>
            </Card>
            <Card className='w-full bg-white px-3 !py-2 rounded-md h-fit'>
              <p className='text-gray-900 text-2xs'>Hasta</p>
              <p>{dateFormat(customPeriod?.endDate, 'dd-MM-yyyy')}</p>
            </Card>
          </div>
        )}
      </div>
      {isCalendarVisible && (
        <div className='text-center'>
          <DateRange
            className='my-demo'
            onChange={(ranges) =>
              setCustomPeriod((cp) => ({ ...cp, ...ranges.selection }))
            }
            ranges={[customPeriod]}
            monthDisplayFormat='MMMM yyy'
            months={1}
            locale={locales.es}
            direction='horizontal'
            showMonthAndYearPickers
            showMonthArrow
            showDateDisplay={false}
            maxDate={new Date()}
            minDate={sub(new Date(), { days: 90 })}
          />
        </div>
      )}
    </>
  )
}
